import { StatusBadge, type StatusTone } from "@/components/status-badge";
import type { BulkStatementRunSummary } from "@/lib/statement-runs";

export type BulkRunStatus = BulkStatementRunSummary["status"];

const tone: Record<BulkRunStatus, StatusTone> = {
  Pending:            "neutral",
  Running:            "info",
  Completed:          "success",
  CompletedWithErrors: "warning",
  Cancelled:          "muted",
};

const label: Record<BulkRunStatus, string> = {
  Pending:            "Pending",
  Running:            "Running",
  Completed:          "Completed",
  CompletedWithErrors: "Completed with errors",
  Cancelled:          "Cancelled",
};

export interface BulkRunStatusBadgeProps {
  status: BulkRunStatus;
}

export function BulkRunStatusBadge({ status }: BulkRunStatusBadgeProps) {
  return (
    <span data-testid="bulk-run-status-badge">
      <StatusBadge tone={tone[status]}>{label[status]}</StatusBadge>
    </span>
  );
}
